var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hoc_"},[_c('MainForm',{attrs:{"definedLanguage":_vm.definedLanguage,"redirectUrl":_vm.redirectUrl,"clientId":_vm.clientId,"clientSecret":_vm.clientSecret,"environment":_vm.environment,"showSeeTypes":_vm.showSeeTypes,"genderEnabled":_vm.genderEnabled,"detailedEducation":_vm.detailedEducation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }